import React, { Component } from 'react';
import { RESTExecutor, withDomains } from '../../../lib/domain';
import ErrorWrapper from '../../../lib/error_wrapper';
import { PopUpForm } from '../../../lib/ui/popupform';
import { Table, Button, Row, Input, Divider, Popconfirm, message, Tag, Drawer } from 'antd';
import Title from 'antd/lib/typography/Title';
import { Link } from 'react-router-dom';
import { showErrorInNotification, overrideHeaderTitle, overrideHeaderBack, NetworkDelaySearch, formatMoney } from '../../../lib/util';
import { BasicHeader } from '../../../components/basic_header';
import { TransparentButton } from '../../../components/basic_items';


const balances_cols = ({ onEditPressed, onDeletePressed }) => [
    {
        title: "Source", dataIndex: '__references__', key: 'source_id', render: (ref = {}) => {
            let source = ref.source_id || {};
            return source.name
        }
    },
    {
        title: "Balance",
        dataIndex: 'opening_balance',
        key: 'opening_balance',

    },
    {
        title: "Date",
        dataIndex: 'date',
        key: 'date',

    },
    {
        title: "",
        dataIndex: 'id',
        key: 'id',
        width: 40,
        render: (id, data) => {
            return <span>
                <Button type='link' onClick={() => {
                    typeof onEditPressed === 'function' && onEditPressed(data)
                }}>Edit</Button>
                {/* <Divider type='vertical'/>
          <Popconfirm title="Are you sure you want to delete this source?" onConfirm={()=>{
            typeof onDeletePressed==='function'&&onDeletePressed(data)
          }}>
          <Button type='link' style={{color:'red'}}>Delete</Button>
          </Popconfirm> */}
            </span>
        }
    }

]
class DatatypeBalances extends Component {
    constructor(props) {
        super(props)
        this.datatype_id = props.match.params.datatype_id;


        this.state = {
            filter_query: {
                per_page: 100,
                page: 1
            },
        };

        this.list_balances = RESTExecutor.list().config({
            label: 'balance_list',
            params: {
                ...this.state.filter_query
            }
        }).forId(this.datatype_id).connect(props.domains.datatype);

        this.post_balances = RESTExecutor.post().config({
            label: 'balance_list'
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                // this.props.history.push(`/settings/datatype/${this.datatype_id}/pipelines/${success.result.id}`)
                this.list_balances.execute()
            }).forId(this.datatype_id)
            .connect(props.domains.datatype);

        this.patch_balance = RESTExecutor.patch().config({
            label: 'balance_detail',
            params: {
                datatype_id: this.datatype_id,
                balance_id: ""
            }
        })
            .callbacks((success) => {
                this.setState({
                    form_visibility: false,
                    edit_id: null,
                    form_data: {}
                });
                this.list_balances.execute()
            })
            .connect(props.domains.datatype);

        this.delete_balance = RESTExecutor.delete().config({
            label: 'balance_detail',
            params: {
                datatype_id: this.datatype_id,
                balance_id: ""
            }
        })
            .callbacks((success) => {
                message.success("Balance deleted.")
                this.list_balances.execute()
            }, (error) => {
                showErrorInNotification(error)
            })
            .connect(props.domains.datatype);

        this.list_balances.execute();

        this.delay_search=new NetworkDelaySearch();

    }

    handlePostPatch = (data) => {
        if (this.state.edit_id) {
            this.patch_balance.config({
                params: {
                    datatype_id: this.datatype_id,
                    balance_id: this.state.edit_id
                }
            }).execute(data);
        } else {
            this.post_balances.forId(this.datatype_id).execute(data);
        }
    }

    stateUpdater = ({
        stateKey,
        valueKey,
        value,
        appendObj = {},
        callback
    }) => {
        let newData = this.state[stateKey];
        this.has_changed = true;
        if (valueKey) {
            newData[valueKey] = value;
        }
        if (appendObj) {
            Object.assign(newData, appendObj)
        }
        console.log(newData);
        this.setState({
            [stateKey]: newData
        }, () => {
            typeof callback === 'function' && callback()
        })
    }


    render() {

        const balance_schema = [
            { name: "Source", index: 'source_id', type: 'networkselect', show_update: false, url: '/sources' },
            { name: "Opening Balance", index: 'opening_balance', type: 'number' },
            { name: "Date", index: 'date', type: 'date' }
        ]

        const { filter_query } = this.state;

        let list_balances_resp = this.list_balances.response();
        let post_balance_resp = this.post_balances.response();
        let patch_balance_resp = this.patch_balance.response();

        let rowsData = (list_balances_resp.result && list_balances_resp.result.rows) || [];
        let rowsMeta = list_balances_resp.meta || {};
        return (
            <div>

<BasicHeader  title="Balances"
                    right={[
                        <TransparentButton
                            label="Add New"
                            hint="Add New Balance"
                            onClick={() => {
                                this.setState({ form_data: {}, edit_id: null, form_visibility: true })
                            }}

                        />,
                    ]}

                />
                 <div className='filter-card'>
                    <div className='filter-card-top' style={{
                        display: 'flex',
                        flexDirection: 'row',
                        justifyContent: 'space-between',
                        flexWrap: 'nowrap',
                    }}>
                         <Input.Search
                                        placeholder="Search For"
                                        style={{
                                        }}
                                        autoFocus
                                        value={filter_query.query}
                                        onChange={(e) => {
                                            this.stateUpdater({ stateKey: 'filter_query', valueKey: 'query', value: e.target.value,callback:()=>{
                                                this.delay_search.onSearch(()=>{
                                                    this
                                                    .list_balances
                                                    .config({
                                                        params: {
                                                            ...filter_query
                                                        }
                                                    })
                                                    .execute()
                                                })
                                            } })
                                        }}
                                        />
                        </div>
                    </div>
                <ErrorWrapper
                    error={list_balances_resp}
                    onReload={() => {
                        this.list_sources.execute()
                    }}
                >
                    <div
                        className='default-card'
                        style={{
                            padding: 0
                        }}>


                        <Table
                            scroll={{ x: true }}
                            className='main-table'
                            loading={list_balances_resp.fetching}
                            size='small'
                            pagination={{
                                simple: false,
                                position: 'bottom',
                                onChange: (current, size) => {
                                    this.stateUpdater({
                                        stateKey: 'filter_query',
                                        appendObj: {
                                            per_page: size,
                                            page: current
                                        },
                                        callback: () => {
                                            this
                                                .list_sources
                                                .config({
                                                    params: {
                                                        ...filter_query
                                                    }
                                                })
                                                .execute();
                                        }
                                    })
                                },
                                defaultCurrent: 1,
                                current: rowsMeta.pagination && parseInt(rowsMeta.pagination.split('/')[0]),
                                pageSize: (rowsMeta && rowsMeta.requested_count),
                                total: (rowsMeta && rowsMeta.total_count),
                                showTotal: (total, range) => `${formatMoney(range[0],0)}-${formatMoney(range[1],0)} of ${formatMoney(total,0)} items`
                            }} 
                            rowKey={(record) => record.id} columns={balances_cols({
                                onEditPressed: (data) => {
                                    this.setState({
                                        edit_id: data.id,
                                        form_data: JSON.parse(JSON.stringify(data)),
                                        form_visibility: true
                                    })
                                },
                                onDeletePressed: (data) => {
                                    this.delete_balance.config({
                                        params: {
                                            datatype_id: this.datatype_id,
                                            balance_id: data.id
                                        }
                                    }).execute()
                                }
                            })} dataSource={rowsData} />

                    </div></ErrorWrapper>

                <PopUpForm
                    title={"Source"}
                    forCreate={this.state.edit_id
                        ? false
                        : true}
                    initialData={this.state.form_data}
                    fields={balance_schema}
                    open={this.state.form_visibility}
                    networkState={this.state.edit_id
                        ? patch_balance_resp
                        : post_balance_resp}
                    onClose={() => this.setState({ form_visibility: false })}
                    onSubmit={(data) => {
                        console.log("DATA", data);
                        this.handlePostPatch(data);
                    }} />
            </div>
        );
    }


    componentDidMount() {
        overrideHeaderTitle("Balance List");
        overrideHeaderBack('back')
    }
    componentWillUnmount() {
        overrideHeaderBack(null)
    }

    componentDidUpdate = (prevProps) => {
        if (this.props.match.params.datatype_id !== prevProps.match.params.datatype_id) {
            this.datatype_id = this.props.match.params.datatype_id;
            this.list_balances.forId(this.datatype_id).execute();
        };
    };
}

export default withDomains(DatatypeBalances, "datatype");
